import React, { useEffect } from "react";
import classes from "./ServicePopupForm.module.css";
import { FaUser, FaPhone, FaEnvelope, FaComment } from "react-icons/fa";

const ServicePopupForm = ({ onClose }) => {
  // close on ESC key
  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modal}>
        <button className={classes.closeBtn} onClick={onClose}>×</button>

        <form
          className={classes.form}
          action="https://formsubmit.co/help.rcginfo@gmail.com"
          method="POST"
        >
          <h1 className={classes.title2}>Get Career Guidance</h1>

          <div className={classes.inputGroup}>
            <FaUser className={classes.icon} />
            <input type="text" name="name" className={classes.input} placeholder="Your Name" required />
          </div>

          <div className={classes.inputGroup}>
            <FaPhone className={classes.icon} />
            <input
              type="tel"
              className={classes.input}
              placeholder="Mobile Number"
              pattern="[0-9]{10}"
              name="tel"
              required
            />
          </div>

          <div className={classes.inputGroup}>
            <FaEnvelope className={classes.icon} />
            <input type="email" name="email" className={classes.input} placeholder="Your Email" required />
          </div>

          <div className={classes.inputGroup}>
            <FaComment className={classes.icon} />
            <select className={classes.select}  required>
              <option value="" name="">Select Exam</option>
              <option value="NEET" name="NEET">NEET</option>
              <option value="JEE" name="JEE">JEE</option>
              <option value="CET" name="CET">CET</option>
            </select>
          </div>

          <div className={classes.inputGroup}>
            <FaComment className={classes.icon} />
            <input type="text" name= "text" className={classes.input} placeholder="Your Location" required />
          </div>

          <button type="submit" className={classes.hif}>Send</button>
        </form>
      </div>
    </div>
  );
};

export default ServicePopupForm;
